import { useContext } from 'react';
import { ConfigurationContext } from '../contexts/ConfigurationContext';

// ----------------------------------------------------------------------

const useConfiguration = () => useContext(ConfigurationContext);

export default useConfiguration;
